import axios from 'axios';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 45000,
  timeoutErrorMessage: 'El servidor se tardo en responder, intente mas tarde',
});

export default axiosClient;
